/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  hasMany,
  type AsyncBelongsTo,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import type Tag from '@linc-technologies/linced-common/models/posts/tag';
import type School from '@linc-technologies/linced-common/models/school';
import { resolved } from '@linc-technologies/linced-common/utils/arrays';

// Proto: posts.TagCategory.
export default class TagCategory extends Model {
  declare [Type]: 'posts/tag-category';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @attr('string', { defaultValue: '' })
  declare campusId: string;

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('string', { defaultValue: '' })
  declare key: string;

  @hasMany('posts/tag', { async: true, inverse: 'categoryId' })
  declare tags: AsyncHasMany<Tag>;

  @computed('tags.content.[]')
  get tagsArray() {
    return resolved(this.tags);
  }
}
